import React, { KeyboardEvent } from 'react';
import classes from './Search.module.scss';
import { Input } from '../Input';
import { Void } from '../../../models/basic-objects';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { SquareButton } from '../../actions/SquareButton';
import classNames from 'classnames';
import { InputTypes } from '../../../constants/form';
import { InputControllerProps } from '../Input/Input.controller';

export type SearchViewProps = Omit<InputControllerProps, 'actionButton' | 'size' | 'onKeyDown' | 'multiline'> & {
  isFilter?: boolean;
  onReset?: Void;
};

export const SearchView = (props: SearchViewProps): JSX.Element => {
  const search = props.formInstance.watch(props.name);
  const hasValue = search?.length > 0;

  const clearButtonClasses = classNames(classes.ClearButtonContainer, {
    [classes.ClearButtonContainerHidden]: !hasValue
  });

  const onResetHandler = () => {
    // Reset the search field
    props.formInstance.resetField(props.name);

    // If the search field has sticky or default value, set to undefined
    if (props.formInstance.getValues(props.name)) {
      props.formInstance.setValue(props.name, undefined);
    }

    // If a onReset function was passed, call it now
    if (props.onReset) {
      props.onReset();
    }
  };

  const onKeyDownHandler = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && props.action) {
      e.stopPropagation();
      e.preventDefault();
      props.action();
    }
  };

  const searchClasses = classNames(classes.Search, {
    [classes.SearchWithLabel]: !!props.label,
    [classes.SearchWithResetButton]: hasValue,
    [classes.FilterSearch]: props.isFilter
  });

  return (
    <div className={searchClasses}>
      <Input
        formInstance={props.formInstance}
        name={props.name}
        rules={props.rules}
        size={props.isFilter ? 'large' : 'medium'}
        label={props.label}
        helper={props.helper}
        placeholder={props.placeholder}
        readonly={props.disabled}
        action={props.action}
        actionButton={{ icon: SquareButtonIconsEnum.discover, disabled: !hasValue }}
        onKeyDown={e => onKeyDownHandler(e)}
        type={InputTypes.text}
      />
      <div className={clearButtonClasses}>
        <SquareButton
          disabled={props.disabled}
          action={onResetHandler}
          icon={SquareButtonIconsEnum.closeSmall}
          type={'transparent'}
        />
      </div>
      <hr />
    </div>
  );
};
